module.exports = "/fonts/quark-bold.ttf?f2c0af223320ca0044bebdb29698c2bf";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/fonts/Quark/quark-bold.ttf
// module id = u3Sa
// module chunks = 0